export default {
  className: 'messageNotification',
  fields: [
    {
      name: 'messageTitle',
      validators: [
        (val) => val ? null : '消息标题不可为空'
      ]
    },
    {
      name: 'IntroductionEvent',
      validators: [
        (val) => val ? null : '通知详情不可为空'
      ]
    },
    {
      name: 'pictureCombination',
      tooltip: '尺寸16 : 9，建议690px * 388px'
    }
  ],
  search: [
    'messageTitle'
  ],
  hooks: {
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      if (!options.objectId) {
        data.userRecords = []
      }
    }
  }
}
